import React from 'react';
import { BookOpenIcon, FlaskConicalIcon, TrophyIcon } from 'lucide-react';
const cards = [{
  icon: <BookOpenIcon className="h-7 w-7 text-bttf-primary" data-id="element-327" />,
  title: 'FILM HISTORIANS',
  description: 'Researched with the obsession the film deserves.'
}, {
  icon: <FlaskConicalIcon className="h-7 w-7 text-bttf-primary" data-id="element-328" />,
  title: 'ORIGINAL RESEARCH',
  description: 'Production secrets Universal never publicized.'
}, {
  icon: <TrophyIcon className="h-7 w-7 text-bttf-primary" data-id="element-329" />,
  title: 'DEFINITIVE EDITION',
  description: 'The complete cultural chronicle for true fans.'
}];
export const NotACashGrabSection = () => {
  return <section className="py-4 md:py-8 bg-bttf-bg border-t border-bttf-subtext/20 relative overflow-hidden" data-id="element-330">
      <div className="container mx-auto px-4 relative z-10 max-w-4xl" data-id="element-331">
        <h2 className="text-2xl md:text-3xl font-bold font-future tracking-wide text-bttf-text text-center mb-4" data-id="element-332">
          40 Years of Legacy. Documented the Way It Deserves.
        </h2>

        <div className="grid grid-cols-3 md:grid-cols-3 gap-3 md:gap-4 mb-4" data-id="element-333">
          {cards.map((card, index) => <div key={index} className="bg-bttf-bg/80 p-3 md:p-6 rounded-lg border border-bttf-subtext/20 flex flex-col items-center text-center" data-id="element-334">
              <div className="flex justify-center mb-2 md:mb-3 p-2 md:p-3 bg-bttf-primary/10 rounded-full border border-bttf-primary/20" data-id="element-335">
                {card.icon}
              </div>
              <h3 className="text-[10px] md:text-sm font-bold mb-1 md:mb-2 text-bttf-primary font-future tracking-widest uppercase leading-tight" data-id="element-336">
                {card.title}
              </h3>
              <p className="text-bttf-subtext font-body text-[10px] md:text-sm leading-relaxed" data-id="element-337">
                {card.description}
              </p>
            </div>)}
        </div>

        <p className="text-center text-bttf-subtext italic font-body text-sm" data-id="element-338">
          Every page earns its place. Zero fluff. Pure insight.
        </p>
      </div>
    </section>;
};